import cartData from '#shared/util/cartData.js';
import invalidCartRedirectMiddleware from '#shared/middleware/invalidCartRedirectMiddleware.js';
import loadOrderMiddleware from '#shared/middleware/loadOrderMiddleware.js';

import cBillingSummary from '#themes/default/default/components/billingSummary/billingSummary.js';
import cButton from '#themes/default/default/components/button/button.js';
import cCompanySummary from '#themes/default/default/components/companySummary/companySummary.js';
import cOrderSummary from '#themes/default/default/components/orderSummary/orderSummary.js';

import pageHeader from '#frontend/util/pageHeader.js';

import template from './invoice.html' with { type: 'html' };

export default {
	...cartData,
	middleware: [
		invalidCartRedirectMiddleware,
		loadOrderMiddleware
	],
	components: {
		cBillingSummary,
		cButton,
		cCompanySummary,
		cOrderSummary
	},
	meta() {
		return {
			title: `${this.t('global_metaTitle')} - ${this.t('invoice_metaTitle')}`
		};
	},
	computed: {
		getHeadline() {
			return pageHeader({
				isNewCart: this.isNewCart,
				isNewMethod: this.isNewMethod,
				order: this.order,
				page: this.page,
				payment: this.payment,
				t: this.t
			});
		},
		orderDate() {
			const date = new Date(this.order.orderDate);
			const locale = this.theme.provider.locale.split('_').join('-');
			return date.toLocaleDateString(locale, {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric'
			});
		},
		merchantAddress() {
			const entityCode = this.$store.state.order.entityCode;
			const entityCodeInvoice = this.$store.state.order.entityCodeInvoice;
			const localizationKey = `providerEntityAddress_${entityCodeInvoice || entityCode}`;
			const localizationString = this.$store.state.localization[localizationKey];
			return this.t(localizationString ? localizationKey : `providerEntityAddress_default[${this.theme.provider.name}]`);
		}
	},
	mounted() {
		this.utils.hideLoader();
		// Add tracking
		this.tracking.invoicePage({
			url: this.url,
			page: this.page,
			order: this.order,
			theme: this.theme,
			app: this.app,
			selectedPayment: this.selectedPayment
		});
	},
	methods: {
		print() {
			window.print();
		}
	},
	template
};
